import React, { useState } from "react";
import "./AdminNavbar.css";
import { Link } from "react-router-dom";

function AdminNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
  localStorage.removeItem("isLoggedIn"); // login flag hatao
  window.location.href = "/admin"; // login page pe redirect
};


  return (
    <nav className="admin-navbar">
      {/* Left side - Brand */}
      <Link to="/admin/dashboard" className="navbar-left" style={{ textDecoration: "none", color: "inherit" }}>
        <h1 className="brand-name">HIMCHATTERJEE</h1>
        <p className="tagline">Visual Artist</p>
      </Link>

      {/* Hamburger button (only for small screens) */}
      <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>

      {/* Center + Logout in dropdown (mobile) */}
      <div className={`navbar-center ${menuOpen ? "open" : ""}`}>
        <a href="/admin/admingallery">MY GALLERY</a>
        <a href="/admin/adminmessages">MESSAGES</a>
        <a href="/admin/adminaddimage">ADD IMAGE</a>
        <a href="/admin/adminsettings">SETTINGS</a>
        <a href="/admin/adminslider">SLIDER</a>
        <a href="/admin/admincollections">COLLECTIONS</a>
        <a href="/admin/adminphotogallery">PHOTO GALLERY</a>
        <a href="/admin/adminupdates">LATEST UPDATES</a>

        {/* Logout button should only appear inside menu on mobile */}
        <div className="mobile-logout">
          <button className="logout-btn">Logout</button>
        </div>
      </div>

      {/* Desktop logout (hide in mobile) */}
      <div className="navbar-right">
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
      </div>

    </nav>
  );
}

export default AdminNavbar;
